import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="mb-8">
    <ol className="flex flex-wrap items-center gap-1.5 font-mono text-[10px] sm:text-[11px] tracking-[0.14em] uppercase">
      {items.map((it, i) => (
        <li key={it.path + it.name} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight size={11} className="text-white/40" aria-hidden="true" />}
          {i < items.length - 1 ? (
            <Link to={it.path} className="text-white/75 hover:text-accent transition-colors">
              {it.name}
            </Link>
          ) : (
            <span className="text-accent" aria-current="page">{it.name}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);
